var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#DC3545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0391 23.9744C47.8313 23.9744 48.5016 24.6447 48.5016 25.4369C48.5016 26.29 47.8313 26.8994 47.0391 26.8994H46.3078L44.8453 46.7041C44.6625 48.776 43.0172 50.2994 40.9453 50.2994H28.6969C26.625 50.2994 24.9797 48.776 24.7969 46.7041L23.3344 26.8994H22.6641C21.8109 26.8994 21.2016 26.29 21.2016 25.4369C21.2016 24.6447 21.8109 23.9744 22.6641 23.9744H26.8687L29.1234 20.6229C29.7328 19.7088 30.8297 19.0994 31.9875 19.0994H37.6547C38.8125 19.0994 39.9094 19.7088 40.5187 20.6229L42.7734 23.9744H47.0391ZM31.9875 22.0244C31.8047 22.0244 31.6219 22.1463 31.5609 22.2682L30.4031 23.9744H39.2391L38.0812 22.2682C38.0203 22.1463 37.8375 22.0244 37.6547 22.0244H31.9875ZM43.3828 26.8994H26.2594L27.7219 46.5213C27.7828 47.0088 28.2094 47.3744 28.6969 47.3744H40.9453C41.4328 47.3744 41.8594 47.0088 41.9203 46.5213L43.3828 26.8994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircleIcon);
export default __webpack_public_path__ + "static/media/deleteCircleIcon.99c50451ae55811753edf29070bd4205.svg";
export { ForwardRef as ReactComponent };